import { COMMISSIONS_ENDPOINT } from '../../endpoints'
import axios from 'axios'

export const getPolicy = async id => {
  const response = await axios.get(`${COMMISSIONS_ENDPOINT}/${id}/getIncentives`);
  return response.data
}